export default __webpack_public_path__ + "static/media/TVS_King_gs+_catalogo.416cfc40.pdf";